module.exports = __webpack_public_path__ + "img/customize-bg.d2a55649.png";